import { path } from 'ramda';

const GlobalSettings = (data) => path(['story', 'content'], data)

export { GlobalSettings }
